import Phaser from 'phaser';
import { mapSize, tileSize } from '../consts/sizes';
import { orange, red, green, blue, pink } from '../game/colors';
import Game from './Game';

export default class Start extends Phaser.Scene {
	public static SceneName = 'StartScene';

	private startButton!: Phaser.Input.Keyboard.Key;
	private pushStartText?: Phaser.GameObjects.Text;
	private pad!: Phaser.Input.Gamepad.Gamepad;

	constructor() {
		super(Start.SceneName);
	}

	startGame() {
		this.scene.pause();
		this.scene.setVisible(false);
		this.scene.launch(Game.SceneName, { init: true });
	}

	create() {
		if (this.input.gamepad.total === 0) {
			this.input.gamepad.once('connected', pad => {
				this.pad = pad;
				this.startGame();
			});
		} else {
			this.pad = this.input.gamepad.pad1;
		}

		const centeredEmulogic = {
			fontSize: '24px',
			fontFamily: 'Emulogic',
			align: 'center'
		};

		this.startButton = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);

		this.startButton.once('up', () => {
			this.startGame();
		});

		const stepTile = 5;
		const startY = 3 * tileSize * mapSize.y / 4;

		this.add.image(
			tileSize * mapSize.x / 2,
			startY - tileSize * stepTile * 2,
			'title'
		)
			.setOrigin(0.5, 1)
			.setScale(0.8)
			.setTint(pink.color);

		this.pushStartText = this.add.text(
			tileSize * mapSize.x / 2,
			startY - tileSize * stepTile,
			`PUSH ANY BUTTON`, {
			color: orange.rgba,
			...centeredEmulogic
		}).setOrigin(0.5, 0);

		this.pushStartText = this.add.text(
			tileSize * mapSize.x / 2,
			startY,
			`1 PLAYER ONLY`, {
			color: blue.rgba,
			...centeredEmulogic
		}).setOrigin(0.5, 0);

		this.pushStartText = this.add.text(
			tileSize * mapSize.x / 2,
			startY + tileSize * stepTile,
			`BONUS LEBAB-MAN FOR 10000 pts`, {
			color: red.rgba,
			...centeredEmulogic
		}).setOrigin(0.5, 0);

		this.pushStartText = this.add.text(
			tileSize * mapSize.x / 2,
			startY + tileSize * stepTile * 2,
			`NETLAB ARCADE`, {
			color: green.rgba,
			...centeredEmulogic
		}).setOrigin(0.5, 0);
	}
}
